import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Table } from 'reactstrap'

import EditTableRow from './partials/EditTableRow'

import style from './style'

export const AccountDetails = props => {
  if (!props.user) {
    return null
  }

  return (
    <Row key={0}>
      <Col>
        <Table
          responsive
          className={css(
            style.table.table,
            style[props.theme.name] ? style[props.theme.name].table.table : null
          )}
        >
          <thead>
            <tr>
              <th
                width={`20%`}
                className={css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}
              />
              <th
                className={css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}
              />

              <th
                width={`100px`}
                className={`d-none d-md-table-cell ${css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}`}
              />
            </tr>
          </thead>
          <tbody>
            <RenderTableRow
              theme={props.theme}
              title={`Full Name`}
              content={`${props.user.firstName} ${props.user.lastName}`}
              onClick={e => props.onTRClick(`fullName`, e)}
              editor={props.editor}
              name={`fullName`}
              editComponent={() => (
                <EditTableRow
                  title={`Full Name`}
                  onInputChange={e => props.onInputChange(`fullName`, e)}
                  onFormSubmit={e => props.onFormSubmit(`fullName`, e)}
                  onCancelClick={e => props.onTRClick(`fullName`, e)}
                  editor={props.editor}
                  content={[
                    {
                      type: 'input',
                      label: 'First Name',
                      name: 'firstName',
                      value: props.editor.inputs.firstName
                    },
                    {
                      type: 'input',
                      label: 'Surname',
                      name: 'lastName',
                      value: props.editor.inputs.lastName
                    }
                  ]}
                />
              )}
              editable
            />
            <RenderTableRow
              theme={props.theme}
              title={`Email`}
              content={props.user.email}
              onClick={e => props.onTRClick('email', e)}
              editor={props.editor}
              name={`email`}
              editComponent={() => (
                <EditTableRow
                  title={`Email`}
                  onInputChange={e => props.onInputChange(`email`, e)}
                  onFormSubmit={e => props.onFormSubmit(`email`, e)}
                  onCancelClick={e => props.onTRClick(`email`, e)}
                  editor={props.editor}
                  content={[
                    {
                      type: 'input',
                      label: 'Email Address',
                      name: 'email',
                      value: props.editor.inputs.email
                    },
                    {
                      type: 'bNote',
                      style: 'italic',
                      value:
                        'Note: Please, make sure you enter valid email format.'
                    }
                  ]}
                />
              )}
              editable
            />
            <RenderTableRow
              theme={props.theme}
              title={`Steam URL`}
              content={props.user.steamUrl}
              onClick={e => props.onTRClick('steamUrl', e)}
              editor={props.editor}
              name={`steamUrl`}
              editComponent={() => (
                <EditTableRow
                  title={`Steam URL`}
                  onInputChange={e => props.onInputChange(`steamUrl`, e)}
                  onFormSubmit={e => props.onFormSubmit(`steamUrl`, e)}
                  onCancelClick={e => props.onTRClick(`steamUrl`, e)}
                  editor={props.editor}
                  content={[
                    {
                      type: 'input',
                      label: 'Steam URL',
                      name: 'steamUrl',
                      value: props.editor.inputs.steamUrl
                    },
                    {
                      type: 'bNote',
                      style: 'italic',
                      value:
                        'Note: Please, make sure you enter valid STEAM profile ID format.'
                    },
                    {
                      type: 'bNote',
                      style: 'italic',
                      value: 'https://steamcommunity.com/id/<ID>'
                    }
                  ]}
                />
              )}
              editable
            />
            <RenderTableRow
              theme={props.theme}
              title={`Phone Number`}
              content={props.user.phone}
              onClick={e => props.onTRClick('phone', e)}
              editor={props.editor}
              name={`phone`}
              editComponent={() => (
                <EditTableRow
                  title={`Phone Number`}
                  onInputChange={e => props.onInputChange(`phone`, e)}
                  onFormSubmit={e => props.onFormSubmit(`phone`, e)}
                  onCancelClick={e => props.onTRClick(`phone`, e)}
                  editor={props.editor}
                  content={[
                    {
                      type: 'input',
                      label: 'Phone Number',
                      name: 'phone',
                      value: props.editor.inputs.phone
                    }
                  ]}
                />
              )}
              editable
            />
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

const RenderTableRow = props => {
  if (
    props.editor.active &&
    props.editor.field === props.name &&
    props.editComponent
  ) {
    return props.editComponent()
  }

  return (
    <tr
      className={css(
        style.table.tr,
        style[props.theme.name] ? style[props.theme.name].table.tr : null,
        !props.editable
          ? style[props.theme.name]
            ? (style.tableRow.nonEditable,
              style[props.theme.name].tableRow.nonEditable)
            : style.tableRow.nonEditable
          : null
      )}
      onMouseEnter={props.onMouseOver}
      onMouseLeave={props.onMouseOver}
      onClick={props.onClick}
    >
      <td
        className={css(
          style.table.td,
          style[props.theme.name] ? style[props.theme.name].table.td : null
        )}
      >
        <span
          className={css(
            style.tableRow.title,
            style[props.theme.name]
              ? style[props.theme.name].tableRow.title
              : null
          )}
        >
          {props.title}
        </span>
      </td>
      <td
        className={css(
          style.table.td,
          style[props.theme.name] ? style[props.theme.name].table.td : null
        )}
      >
        <span
          className={css(
            style.tableRow.content,
            style[props.theme.name]
              ? style[props.theme.name].tableRow.content
              : null
          )}
        >
          {props.content || ''}
        </span>
      </td>
      <td
        className={`d-none d-md-table-cell ${css(
          style.table.td,
          style[props.theme.name] ? style[props.theme.name].table.td : null
        )}`}
      >
        <div
          className={`d-flex justify-content-center align-items-center ${css(
            style.tableRow.edit,
            !props.editable
              ? style[props.theme.name]
                ? (style.tableRow.nonEditableEdit,
                  style[props.theme.name].tableRow.nonEditableEdit)
                : style.tableRow.nonEditableEdit
              : null
          )}`}
        >
          <i
            className={`fa fa-pencil`}
            // style={{ opacity: +!!props.state.isHover }}
          />
          <span
            className={css(style.tableRow.editSpan)}
            // style={{
            //   textDecoration:
            //     !!props.state.isHover && props.editable ? `underline` : `none`
            // }}
          >
            Edit
          </span>
        </div>
      </td>
    </tr>
  )
}

export default AccountDetails



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/index.js